import { computed, reaction } from 'mobx'
import { EntityTypeStore } from '@migrate/stores/EntityTypeStore'
import {
  EntityStorageType,
  EntityType as IEntityType,
  EntityTypePowerBiEntity,
} from '@portal/pkg-api/gen/navigator'

export class EntityType implements IEntityType {
  id: number
  store: EntityTypeStore
  autoSave: boolean
  /**
   * Disposer for the side effect that automatically
   * stores this class, see @dispose.
   */
  saveHandler: () => void
  isDeleted: boolean

  code: string
  name: string
  storageType: EntityStorageType
  orgId?: number
  version: number
  description?: string
  enabled: boolean
  iconUrl?: string
  color?: string
  effectiveColor: string
  sortOrder?: number
  features: string[]
  parentEntityId?: number
  status?: string
  successors: IEntityType[]
  requiresSubEntity: boolean
  powerBiEntity?: EntityTypePowerBiEntity

  constructor(store: EntityTypeStore, id: number) {
    this.store = store
    this.id = id
    this.autoSave = false
    this.isDeleted = false
    this.code = ''
    this.name = ''
    this.storageType = EntityStorageType.EAV
    this.effectiveColor = ''
    this.features = []
    this.successors = []
    this.requiresSubEntity = false
    this.enabled = false
    this.version = 1

    this.saveHandler = reaction(
      // observe everything that is used in the JSON:
      () => this.asJson,
      // if autoSave is on, send json to server
      (_json) => {
        if (this.autoSave) {
          // this.store.transportLayer.updateEntityType(json)
        }
      },
    )
  }

  @computed
  get asJson() {
    return {
      id: this.id,
      orgId: this.orgId,
      code: this.code,
      name: this.name,
      version: this.version,
      description: this.description,
      enabled: this.enabled,
      iconUrl: this.iconUrl,
      color: this.color,
      effectiveColor: this.effectiveColor,
      sortOrder: this.sortOrder,
      requiresSubEntity: this.requiresSubEntity,
      storageType: this.storageType,
      powerBiEntity: this.powerBiEntity,
    }
  }

  /**
   * Update with information from the server
   */
  updateFromJson(json: EntityType) {
    // make sure our changes aren't sent back to the server
    this.autoSave = false

    this.code = json.code
    this.orgId = json.orgId
    this.name = json.name
    this.version = json.version
    this.description = json.description
    this.enabled = json.enabled
    this.iconUrl = json.iconUrl
    this.color = json.color
    this.effectiveColor = json.effectiveColor
    this.sortOrder = json.sortOrder
    this.features = [...json.features]
    this.parentEntityId = json.parentEntityId
    this.status = json.status
    this.successors = [...json.successors]
    this.requiresSubEntity = json.requiresSubEntity
    this.storageType = json.storageType
    this.autoSave = true
    this.powerBiEntity = json.powerBiEntity
  }

  dispose() {
    // clean up the observer
    if (this.saveHandler) {
      this.saveHandler()
    }
  }
}
